export const MESSAGE_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
} as const

export const PART_TYPES = {
  UI_COMPONENT: 'ui_component',
  TEXT: 'text',
} as const

export const UI_COMPONENT_TYPES = {
  PILLS_LIST: 'pills_list',
  CARDS_LIST: 'cards_list',
  CAROUSEL: 'carousel',
  FLIGHT_RECOMMENDATIONS: 'flight_recommendations',
  SIGN_UP_MODAL: 'sign_up_modal',
  CONFIRMATION_PROMPT: 'confirmation_prompt',
  EXPERIENCE_VOUCHER: 'experience_voucher',
  CUSTOM_FLIGHT: 'custom_flight',
  TESTIMONIAL: 'testimonial',
  HOTEL_ROOM_OPTIONS: 'hotel_room_options',
  GOOGLE_PLACE: 'google_place',
  MAP: 'map',
} as const
